import React, { useState } from 'react';
import { Window, WindowActionsBar } from '@progress/kendo-react-dialogs';
import { Button } from '@progress/kendo-react-buttons';
import { useNavigate, useParams } from 'react-router-dom';
import { UserApi } from '../../../../redux/api/UserApi';
import * as svg from '@progress/kendo-svg-icons';
import { TicketApi } from '../../../../redux/api/TicketApi';
import { IAction, IActionDTO } from '../../../../types/Action/IAction';
import { toast } from 'react-toastify';
import { PartialSpinny } from '../../../Nav/Spinny';

const DeleteAction: React.FC = () => {
    const { actionId: id, ticketId } = useParams();
    const navigate = useNavigate();
    const { data: profile } = UserApi.useGetUserProfileQuery();
    //Get existing action
    const { data: action, isFetching: fetchingAction } = TicketApi.useGetActionQuery({ actionId: parseInt(id), ticketId: parseInt(ticketId) }, { skip: !id });
    const [deleteAction, { isLoading: deleting }] = TicketApi.useDeleteActionMutation();

    const handleClose = () => {
        navigate(-1);
    };

    const handleConfirm = () => {
        if (!action) return;
        if (!canDelete(action)) { alert('You do not have permissions to delete this action'); return false; }

        var actionToDelete = { ID: action.ID, Call_Id: action.Call_Id } as IActionDTO;

        //Delete via API
        deleteAction(actionToDelete).unwrap().then(() => {
            toast.success('Action Deleted');
            //Go Back
            navigate(-1);
        });
    };

    //Decides if the user can edit this action
    const canDelete = (action: IAction) => {
        //temporarily enabled for testing
        //return true;

        if (!action || action?.Is_System_Action) return false;
        if (profile?.Features.Delete_Any_Action) return true;
        if (profile?.Features.Delete_My_Actions && action.Staff_Id == profile?.Id) return true;
        return false;
    }


    return (
        <>
            <Window modal={true} minimizeButton={() => null} maximizeButton={() => null} className='cool-window' title="Confirm Delete" onClose={handleClose} width={350} height={160}>
                {deleting && <PartialSpinny />}
                {fetchingAction ? <div>Loading...</div> :
                    <>
                        <div>
                            {canDelete(action) ?
                                <p>Are you sure you want to delete this {profile?.Phrases.Action}?</p>
                                : <p>You do not have permission to delete this {profile?.Phrases.Action}!</p>}
                        </div>
                        <WindowActionsBar layout='center'>
                            {canDelete(action) &&
                                <Button autoFocus={true} onClick={handleConfirm} svgIcon={svg.trashIcon} style={{ width: '150px', color: '#fff', background: profile?.Nav_Hex_Color }}>
                                    Delete {profile?.Phrases.Action}
                                </Button>}
                            <Button onClick={handleClose}>Cancel</Button>
                        </WindowActionsBar></>
                }
            </Window></>
    );
};

export default DeleteAction;